<template>
  <div class="container" v-loading="true"></div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddRouterFunc from "@/router/addRouter";
import routeData from "@/router/routerData";
export default {
  data() {
    return {};
  },
  created() {
    //清空缓存
    this.$store.commit("SET_ACCESS_TOKEN", null);
    this.$store.commit("SET_MENU", []);
    this.$store.commit("SET_PERMISSIONS", []);
    this.$store.commit("SET_CHOOSE_DEPT", []);
    // this.$store.commit("SET_ChOOSE_DATASCOPE_DEPT", []);
    this.$store.commit("SET_LOG_MSG", null);
    this.$store.commit("SET_ACTIVES", null);
    this.$store.commit("SET_ACTIVE_TAG", null);
    window.sessionStorage.setItem("nz_access_token", null);
    // sessionStorage.clear()
    // localStorage.clear();
    this.storageClear();

    this.init();
  },
  methods: {
    ...mapActions(["setUserToken", "setUserData", "logout", "setAccessToken", "bpmnSecurityLoginHandle"]),
    storageClear() {
      localStorage.removeItem("userData");
      localStorage.removeItem("token");
      sessionStorage.removeItem("vuex");
      sessionStorage.removeItem("nz_access_token");
      sessionStorage.removeItem("setConfig");
      sessionStorage.removeItem("userData");
    },
    init() {
      this.$store
        .dispatch("LoginByUsername", {
          username: "admin",
          password: "Maiyue_2021",
          code: "",
          randomStr: ""
        })
        .then(async res => {
          if ("access_token" in res.data) {
            // await this.bpmLogin(res.data.username)
            window.sessionStorage.setItem("nz_access_token", "Bearer " + res.data.access_token);
            // 获取组织部门树
            this.$store
              .dispatch("getDeptTree")
              .then(() => {})
              .catch(err => {
              });
            this.bpmnSecurityLoginHandle({
              userName: res.data.username,
              deviceType: "pc"
            }).catch(() => {
              // this.$store.commit("SET_ACCESS_TOKEN", null);
              // sessionStorage.removeItem('nz_access_token')
            });
            //获取用户权限
            this.$store
              .dispatch("GetUserPermissions")
              .then(res => {
                //获取个人菜单;
                let userInfo = {
                  deviceType: "pc",
                  userId: res.data.sysUser.userId,
                  userImg: res.data.sysUser.avatar,
                  userName: res.data.sysUser.username,
                  deptId: res.data.sysUser.deptId,
                  roleCodes: res.data.roleCodes
                };
                let routerData = res.data.permissions;
                routerData = [
                  ...routerData,
                    '/office',
                    '/test',
                    '/statistical/all',
                    '/ServeCenterDetail',
                    '/notifyDetail',
                    '/serveEvaluate',
                    '/search',
                    '/noticesAndFilesPagination',
                    '/fileDetail',
                    '/teacherTimetable',
                    '/staff',
                    '/jobshire',
                    '/annualappraisal',
                    '/wage',
                    '/classroomQuery',
                ];
                if ((res.data.roleCodes || []).includes("ROLE_ADMIN")) {
                  routerData = [];
                  const routeHandler = function(arr) {
                    for (let i = 0; i < arr.length; i++) {
                      routerData.push(arr[i].path);
                      if (arr[i].children) {
                        routeHandler(arr[i].children);
                      }
                    }
                  };
                  routeHandler(routeData);
                  routerData = routerData.concat([
                    "system-management",
                    "business-management",
                    "advices-management",
                    "efficiency-management",
                    "data-management"
                  ]);
                }

                this.setUserData({
                  ...userInfo,
                  routerData
                });

                localStorage.setItem(
                  "userData",
                  JSON.stringify({
                    ...userInfo,
                    routerData
                  })
                );

                sessionStorage.setItem("loginFrom", "system");

                this.logining = false;

                const routers = AddRouterFunc.getNewRouerData(routerData);
                this.$router.addRoutes(routers);

                this.$router.push("/");
              })
              .catch(err => {
              });
          } else {
            this.logining = false;
          }
        })
        .catch(err => {
          this.$message.error("登录出错");
        });
    }
  }
};
</script>

<style>
.container {
  height: 100%;
  width: 100%;
}
</style>
